module.exports = __webpack_public_path__ + "img/icon-wifi-off.2238275a.svg";